// Copyright (c) Docugami, Inc. All rights reserved.

import { CoachMarkTracker } from "coachmarks/CoachMarkTracker";
import { CoachMarkId } from "coachmarks/CoachMarkTypes";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "store";

export interface ITrackedCoachMark {
    value: boolean;
    setValue: (value: boolean) => void;
}

export function useTrackedCoachMark(id: CoachMarkId): ITrackedCoachMark {
    const [value, setValue] = useState<boolean>(false);
    const orgId = useSelector((state: AppState) => state.organizations.currentOrganization?.id);

    useEffect(() => {
        if (!!orgId) {
            setValue(new CoachMarkTracker(orgId).getCoachMark(id));
        }
        else {
            setValue(false);
        }
    }, [orgId, id]);

    const setCoachMark = useCallback((value: boolean) => {
        const tracker = new CoachMarkTracker(orgId);
        if (value) {
            tracker.setCoachMark(id)
        }
        else {
            tracker.clearCoachMark(id);
        }

        setValue(tracker.getCoachMark(id));
    }, [orgId, id])

    return {
        value: value,
        setValue: setCoachMark
    }
}
